import React from 'react';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useAuthContext } from '../AuthContext';

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <path
      d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z"
      fill="#4285F4"
    />
    <path
      d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z"
      fill="#34A853"
    />
    <path
      d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z"
      fill="#FBBC05"
    />
    <path
      d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z"
      fill="#EA4335"
    />
  </svg>
);

const AppleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" aria-hidden="true">
    <path d="M14.92 9.61c-.02-1.9 1.56-2.82 1.63-2.86-0.89-1.3-2.27-1.47-2.76-1.49-1.18-.12-2.3.69-2.9.69-.6 0-1.53-.67-2.52-.65-1.3.02-2.5.76-3.16 1.93-1.35 2.34-.35 5.8.97 7.7.65.93 1.41 1.97 2.42 1.93.97-.04 1.34-.62 2.51-.62 1.18 0 1.51.62 2.54.6 1.04-.02 1.7-.95 2.34-1.89.74-1.08 1.04-2.13 1.06-2.18-.02-.01-2.03-.78-2.13-3.16ZM13.07 3.86c.54-.65.9-1.56.8-2.46-.77.03-1.71.51-2.26 1.15-.5.57-.93 1.49-.81 2.37.86.07 1.73-.44 2.27-1.06Z" />
  </svg>
);

export function SignInScreen() {
  const { setScreen } = useAuthContext();
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<'google' | 'apple' | null>(null);

  const handleSocial = async (provider: 'Google' | 'Apple') => {
    setError(null);
    setLoading(provider === 'Google' ? 'google' : 'apple');
    try {
      await signInWithRedirect({ provider });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed. Please try again.');
      setLoading(null);
    }
  };

  return (
    <div className="fs-auth-fullscreen">
      <div className="fs-auth-card">
        <img
          className="fs-auth-logo"
          src="https://static.focused.space/logo_landscape_1x.png"
          alt="Focused Space"
        />

        <h1 className="fs-auth-heading">Sign in to your Focused Space account</h1>

        <div className="fs-auth-buttons">
          <button
            className="fs-auth-btn fs-auth-btn-social"
            onClick={() => handleSocial('Google')}
            disabled={loading !== null}
          >
            <GoogleIcon />
            Continue with Google
          </button>

          <button
            className="fs-auth-btn fs-auth-btn-social"
            onClick={() => handleSocial('Apple')}
            disabled={loading !== null}
          >
            <AppleIcon />
            Continue with Apple
          </button>

          <div className="fs-auth-divider">or</div>

          <button
            className="fs-auth-btn fs-auth-btn-ghost"
            onClick={() => setScreen('email_input')}
            disabled={loading !== null}
          >
            Sign in with email
          </button>
        </div>

        {error && <p className="fs-auth-error">{error}</p>}
      </div>
    </div>
  );
}
